export default {
    methods: {
        focusAutofocusInput(index = 0, element = this.$el) {
            this.$nextTick(() => {
                if (!element || element.nodeType === 8) {
                    return
                }

                const inputs = element.querySelectorAll('[autofocus]')

                if (inputs[index]) {
                    if (inputs[index].focus) {
                        inputs[index].focus()
                    } else if (inputs[index].select) {
                        inputs[index].select()
                    }
                }
            })
        },
    },

    mounted() {
        this.focusAutofocusInput()
    },
}
